<script>
import Layout from '@layouts/auth'

export default {
  page: {
    title: '403',
    meta: [{ name: 'description', content: '403' }],
  },
  components: { Layout },
  props: {
    resource: {
      type: String,
      default: '',
    },
  },
}
</script>

<template>
  <Layout>
    <div class="row justify-content-center">
                    <div class="col-md-8 col-lg-6 col-xl-5">
                        <div class="card">

                            <div class="card-body p-4">

                                <div class="error-ghost text-center">
                                   <svg id="Layer_3" enable-background="new 0 0 64 64" height="50%" viewBox="0 0 64 64" width="50%" xmlns="http://www.w3.org/2000/svg"><g><path d="m12 62h-6v-51c0-1.657 1.343-3 3-3 1.657 0 3 1.343 3 3z" fill="#4c3524"/><path d="m58 62h-6v-51c0-1.657 1.343-3 3-3 1.657 0 3 1.343 3 3z" fill="#4c3524"/><path d="m2 16h60v12h-60z" fill="#976947"/><g fill="#e8eff4"><path d="m50 28 12-12h-8l-12 12z"/><path d="m30 28 12-12h-8l-12 12z"/><path d="m10 28 12-12h-8l-12 12z"/></g><path d="m2 36h60v12h-60z" fill="#976947"/><path d="m50 48 12-12h-8l-12 12z" fill="#e8eff4"/><path d="m30 48 12-12h-8l-12 12z" fill="#e8eff4"/><path d="m10 48 12-12h-8l-12 12z" fill="#e8eff4"/><path d="m44 8c0 8.746-4.371 16.914-11.649 21.766l-.351.234-.351-.234c-7.278-4.852-11.649-13.02-11.649-21.766l12-6z" fill="#8892a0"/><path d="m35.962 3.981-3.962-1.981-12 6c0 4.24 1.035 8.339 2.922 11.995.026 0 .052.005.078.005 6.926 0 12.571-7.089 12.962-16.019z" fill="#cfd3d9"/><circle cx="32" cy="15" fill="#f7d881" r="6"/><path d="m34.925 9.763c-.866-.484-1.862-.763-2.925-.763-3.314 0-6 2.686-6 6 0 1.51.562 2.886 1.483 3.94 3.336-1.605 6.032-4.934 7.442-9.177z" fill="#fae8b3"/><g><path d="m1 61h62v2h-62z" fill="#8892a0"/></g></g></svg>

                                </div>

                                <div class="text-center">
                                    <h3 class="mt-4 text-uppercase font-weight-bold"> 403 </h3>
                                    <h3 class="mt-4 text-uppercase font-weight-bold">  Pagina no autorizada </h3>
                                    <p class="text-muted mb-0 mt-3" style="line-height: 20px;">Parece que no te tienes permitido el acceso. No te preocupes...
                                        
                                        Aquí hay un pequeño consejo que podría ayudarte a volver al buen camino.</p>

                                    <router-link tag="a" to="/" class="btn btn-primary mt-3"><i class="mdi mdi-reply mr-1"></i> Regresa al inicio</router-link>
                                </div>

                            </div> <!-- end card-body -->
                        </div>
                        <!-- end card -->

                    </div> <!-- end col -->
                </div>
  </Layout>
</template>

<style lang="scss" module>
.title {
  text-align: center;
}
</style>
